<template>
  <div class="s-lk-auth-input" :class="{'s-lk-auth-input--inverse': inverse}">
    <span
      class="s-lk-auth-input__label"
      :class="{ 's-lk-auth-input__label--focused': isFocused || value }"
      >{{ name }}</span
    >
    <div class="s-lk-auth-input__input">
      <input
        v-model="model"
        :type="isPasswordVisible ? 'text' : type"
        :name="name"
        class="ba-w-full ba-text-xl ba-relative ba-bg-transparent"
        :disabled="disabled"
        @focus="onFocus"
        @blur="onBlur"
        @change="$emit('change', model)"
        @keydown.enter="$event.target.blur()"
        autocomplete="on"
      />
      <s-lk-eye-icon
        class="ba-absolute ba-right-0 u-align-v"
        v-if="type === 'password'"
        :class="{ 'ba-cursor-pointer': model }"
        @click.native="isPasswordVisible = !isPasswordVisible"
      />
    </div>
  </div>
</template>

<script>
import SLkEyeIcon from "@/components/smena/icons/s-lk-eye-icon";

export default {
  name: "s-lk-auth-input",
  components: { SLkEyeIcon },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      type: [Number, String],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.value,
      isFocused: false,
      isPasswordVisible: false
    };
  },
  methods: {
    onFocus() {
      this.isFocused = true;
      this.$emit("focus");
    },
    onBlur() {
      this.isFocused = false;
      this.$emit("blur");
    }
  }
};
</script>
